/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalIntegrations_company = {
    readonly harvestEnabled: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly " $refType": "TimeRegistrationModalIntegrations_company";
};
export type TimeRegistrationModalIntegrations_company$data = TimeRegistrationModalIntegrations_company;
export type TimeRegistrationModalIntegrations_company$key = {
    readonly " $data"?: TimeRegistrationModalIntegrations_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModalIntegrations_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalIntegrations_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4Enabled",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '3e4a85aa04776d0de7ff2744e0473a3a';
export default node;
